import React from "react";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import PropTypes from "prop-types";

import PrimaryNormal from "../buttons/PrimaryNormal";

const ExportExcelOthers = ({ arrayData, name }) => {
  const ArrNewData = arrayData?.map((item) => {
    return {
      NOMBRE: item.firstName,
      APELLIDO: item.lastName,
      "CORREO ELECTRÓNICO": item.email,
      "NÚMERO 1": item.phoneNumber,
      "NÚMERO 2": item.secondaryPhoneNumber,
      WHATSAPP: item.optionalPhoneNumber,
      DEPARTAMENTO: item.state.name,
      MUNICIPIO: item.cities.name,
      "BARRIO/DIRECCIÓN": item.neighborhood,
      "NÚMERO RUMV": item.rumvNumber,
    };
  });

  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToExcel = async () => {
    const ws = XLSX.utils.json_to_sheet(ArrNewData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, `${name} ${new Date().toDateString()}${fileExtension}`);
  };

  return (
    <PrimaryNormal title="Exportar" onClick={() => exportToExcel()} style={{ width: 150, height: 30, margin: 0 }} />
  );
};

ExportExcelOthers.propTypes = {
  arrayData: PropTypes.array,
  name: PropTypes.string,
};

export default ExportExcelOthers;
